import { Container, Text } from '@pixi/react'
import { useMemo } from 'react'
import { paragraphStyle, tableTitleStyle } from './textStyle'
import { ParagraphProps } from './Paragraph2'
import { t } from '@slot-nx/core'

export const Paragraph0 = (props: ParagraphProps) => {
  const content = useMemo(() => {
    return (
      <Container y={props.y}>
        <Text
          text={(t('gameRules_title1'))}
          x={props.width / 2}
          y={0}
          anchor={0.5}
          style={tableTitleStyle}
        />

        <Text
          x={60}
          y={80}
          text={(t('gameRules_title1_content_1'))}
          style={paragraphStyle}
        />
        <Text
          x={60}
          y={130}
          text={(t('gameRules_title1_content_2'))}
          style={paragraphStyle}
        />
      </Container>
    )
  }, [])
  return content
}
